var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPendingAgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    fill: "#EC6655"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66699 2.37197L4.90942 5.68571C4.90942 5.8954 5.03063 6.00024 5.27305 6.00024H6.7276C6.97002 6.00024 7.09123 5.8954 7.09123 5.68571L7.33366 2.37197C7.33366 2.25759 7.29326 2.17181 7.21245 2.11462C7.15184 2.03837 7.07103 2.00024 6.97002 2.00024H5.03063C4.92962 2.00024 4.83871 2.03837 4.7579 2.11462C4.6973 2.17181 4.66699 2.25759 4.66699 2.37197Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00033 7.33374C6.36748 7.33374 6.67665 7.46901 6.92786 7.73954C7.19839 7.99075 7.33366 8.29992 7.33366 8.66707C7.33366 9.03422 7.19839 9.35306 6.92786 9.6236C6.67665 9.8748 6.36748 10.0004 6.00033 10.0004C5.63318 10.0004 5.31434 9.8748 5.0438 9.6236C4.7926 9.35306 4.66699 9.03422 4.66699 8.66707C4.66699 8.29992 4.7926 7.99075 5.0438 7.73954C5.31434 7.46901 5.63318 7.33374 6.00033 7.33374Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingAgIcon);
export default __webpack_public_path__ + "static/media/pending-ag-icon.89478c18c74d53b2021464dc0c471f85.svg";
export { ForwardRef as ReactComponent };